import { buildLanguagePath, normalizeLanguage } from "./languageRouting";

const SEO_BY_LANGUAGE = {
  en: {
    title: "Kyiv Mod for Doom | Download KYIV.zip",
    description:
      "Play Kyiv, a Doom mod inspired by the war in Ukraine. Download KYIV.zip and launch it with GZDoom."
  },
  fr: {
    title: "Mod Kyiv pour Doom | Telecharger KYIV.zip",
    description:
      "Jouez a Kyiv, un mod Doom inspire par la guerre en Ukraine. Telechargez KYIV.zip et lancez-le avec GZDoom."
  },
  ua: {
    title: "Kyiv mod dlya Doom | Zavantageyty KYIV.zip",
    description:
      "Kyiv - mod dlya Doom. Zavantageyty KYIV.zip i zapustit cherez GZDoom."
  },
  si: {
    title: "Kyiv mod za Doom | Prenesite KYIV.zip",
    description:
      "Igrajte Kyiv, Doom mod. Prenesite KYIV.zip in ga zazeni z GZDoom."
  }
};

const HREFLANG_BY_LANGUAGE = {
  en: "en",
  fr: "fr",
  ua: "uk",
  si: "sl"
};

const getSiteOrigin = () => {
  if (process.env.REACT_APP_SITE_URL) {
    return process.env.REACT_APP_SITE_URL.replace(/\/+$/, "");
  }
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "https://kyiv.200.work";
};

const ensureTag = ({ selector, createTag, attributes }) => {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement(createTag);
    document.head.appendChild(tag);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    tag.setAttribute(key, value);
  });

  return tag;
};

const upsertMetaByName = (name, content) =>
  ensureTag({
    selector: `meta[name="${name}"]`,
    createTag: "meta",
    attributes: { name, content, "data-seo": "true" }
  });

const upsertMetaByProperty = (property, content) =>
  ensureTag({
    selector: `meta[property="${property}"]`,
    createTag: "meta",
    attributes: { property, content, "data-seo": "true" }
  });

const upsertCanonical = (href) =>
  ensureTag({
    selector: 'link[rel="canonical"]',
    createTag: "link",
    attributes: { rel: "canonical", href, "data-seo": "true" }
  });

const refreshHrefLangTags = (origin) => {
  document.querySelectorAll('link[data-seo="hreflang"]').forEach((tag) => tag.remove());

  Object.keys(HREFLANG_BY_LANGUAGE).forEach((lang) => {
    const hrefLang = HREFLANG_BY_LANGUAGE[lang];
    const href = `${origin}${buildLanguagePath(lang, "/")}`;
    ensureTag({
      selector: `link[rel="alternate"][hreflang="${hrefLang}"]`,
      createTag: "link",
      attributes: {
        rel: "alternate",
        hreflang: hrefLang,
        href,
        "data-seo": "hreflang"
      }
    });
  });

  ensureTag({
    selector: 'link[rel="alternate"][hreflang="x-default"]',
    createTag: "link",
    attributes: {
      rel: "alternate",
      hreflang: "x-default",
      href: `${origin}${buildLanguagePath("en", "/")}`,
      "data-seo": "hreflang"
    }
  });
};

const applySeoForLanguage = (language) => {
  if (typeof document === "undefined") {
    return;
  }

  const lang = normalizeLanguage(language) || "en";
  const metadata = SEO_BY_LANGUAGE[lang] || SEO_BY_LANGUAGE.en;
  const origin = getSiteOrigin();
  const canonicalPath = buildLanguagePath(
    lang,
    window.location.pathname,
    "",
    ""
  );
  const canonicalUrl = `${origin}${canonicalPath}`;

  document.documentElement.setAttribute("lang", HREFLANG_BY_LANGUAGE[lang] || "en");
  document.title = metadata.title;

  upsertMetaByName("description", metadata.description);
  upsertMetaByName("robots", "index,follow");
  upsertMetaByProperty("og:type", "website");
  upsertMetaByProperty("og:site_name", "Kyiv Mod");
  upsertMetaByProperty("og:title", metadata.title);
  upsertMetaByProperty("og:description", metadata.description);
  upsertMetaByProperty("og:url", canonicalUrl);
  upsertMetaByName("twitter:card", "summary_large_image");
  upsertMetaByName("twitter:title", metadata.title);
  upsertMetaByName("twitter:description", metadata.description);
  upsertCanonical(canonicalUrl);
  refreshHrefLangTags(origin);
};

export { applySeoForLanguage };
